function ref(title, intro, columns, rows) {
  return { title: title, intro: intro, columns: columns, rows: rows }
}

var HUB_PLATFORM_REFS = {
  'seedream-ai-image-generator-review': ref(
    '各平台主图对照',
    '下面是我改 Seedream 5 提示词时会对照的比例和写法——同一款产品换平台，往往只要动背景、比例和一两个形容词。',
    ['平台和用途', '推荐比例', '提示词要点'],
    [
      ['亚马逊主图', '1:1', '纯白背景、产品居中、商业摄影、柔光、材质写清楚'],
      ['亚马逊 A+ 场景图', '1:1 或 16:9', '生活方式、产品使用场景、自然光'],
      ['eBay 和 Etsy 商品页', '1:1 或 4:5', '生活方式、细节特写、产品状态和使用场景写清楚'],
      ['Walmart Marketplace 商品图', '1:1', '干净背景、产品居中、真实材质、少用夸张滤镜'],
      ['Shopify 独立站横幅图', '16:9', '品牌色背景、首屏横幅、产品 + 生活方式元素'],
      ['WooCommerce 和 BigCommerce 商品图', '1:1 或 4:3', '独立站产品图、系列套装、可继续用 FLUX 精修'],
      ['Squarespace 独立站横幅图', '16:9', '留出标题区域、品牌氛围、生活方式场景'],
      ['TikTok Shop 商品图', '1:1 或 9:16', '动感构图、高饱和背景、产品前景清晰'],
      ['Google Shopping 商品广告图', '1:1', '白底或浅背景、产品清楚、避免大段文字'],
      ['Instagram 和 Pinterest', '1:1 或 2:3', '生活方式、产品 + 场景、品牌色和构图写清楚'],
      ['跨境电商白底图', '1:1', '纯白背景、商业摄影、多试几版挑边缘']
    ]
  ),
  'flux-ai-image-generator-review': ref(
    '行业场景对照',
    '不同行业的 FLUX 提示词我通常按下面这张表改关键词，复制一行改产品名就能试。',
    ['行业场景', '摄影关键词', '版本建议'],
    [
      ['3C 和手表微距', '微距、边缘光、冷色调、金属反光', 'FLUX.2 终稿；Schnell 试构图'],
      ['护肤品', '柔光、浅景深、玻璃瓶身、大理石台面', 'FLUX.2'],
      ['珠宝', '微距、黑色背景、边缘光、高端广告', 'Flux Pro Ultra 大图提案'],
      ['美食 / 咖啡', '生活方式摄影、晨光、暖色调、浅景深', 'FLUX.2'],
      ['汽车广告', '雨后霓虹、电影级商业摄影、高对比、低角度', 'FLUX.2 或 Pro Ultra'],
      ['亚马逊和 Shopify 图', '硬光产品摄影、商业广告、干净背景', '和 Seedream 各出一版对比'],
      ['Walmart 和 Target 商品广告图', '真实材质、干净背景、产品前景清楚', '适合家电、户外、日用品'],
      ['Wayfair 家居产品图', '自然光、室内生活方式、家具材质', 'FLUX 交终稿更稳']
    ]
  ),
  'midjourney-alternative-online': ref(
    '替代方案怎么选',
    '同一项目里艺术探索和商业出片常要不同模型——我按需求对照，而不是找一个「万能替代」。',
    ['你的需求', '优先试', '说明'],
    [
      ['概念艺术 / 奇幻插画', 'Midjourney 或 SD 3.5', '风格探索、游戏原画'],
      ['电商主图 / 场景图', 'Seedream 5', '跟描述快，商业场景先试'],
      ['硬质感产品摄影', 'FLUX.2', '交稿质感首选'],
      ['带标题的活动海报', 'GPT Image 1.5', '文字写进画面更可控'],
      ['网页直接用 Midjourney', 'Miral Midjourney', '不用 Discord，浏览器打开'],
      ['多模型同一工作流', 'Miral 工作台', '比 Leonardo、Dreamina、Firefly 之间来回导出省事']
    ]
  ),
  'gpt-image-generator-guide': ref(
    '文字海报类型速查',
    '要把标题写进画面，GPT Image 1.5 我按海报类型整理提示词结构——改标题就能试。',
    ['海报类型', '比例', '提示词结构'],
    [
      ['促销海报和活动横幅图', '16:9 或 3:4', '主标题 + 副标题 + 活动日期 + 风格（复古/极简）'],
      ['电商卖点图', '1:1', '三点条目式卖点 + 产品名 + 极简背景'],
      ['Google Shopping 促销图', '1:1', '短标题 + 产品名 + 折扣信息，文字别太长'],
      ['Shopify 和 WooCommerce 横幅', '16:9', '主标题 + 品牌色 + 产品或生活方式背景'],
      ['社媒封面', '1:1 / 4:5 / 2:3', '平台比例写进提示词；短标题更稳'],
      ['传单', '3:4 或 A4 竖版', '主标题 + 联系方式 + 风格'],
      ['界面样机图', '16:9', '界面布局、按钮、配色、网页或应用标注'],
      ['网站首屏横幅', '16:9', '主标题 + 品牌色 + 产品或场景元素']
    ]
  ),
  'qwen-image-generator-review': ref(
    '营销海报场景速查',
    '做高分辨率海报时，我会先对照比例和场景，再写主标题和产品描述。',
    ['场景', '比例', '提示词要点'],
    [
      ['Instagram 和 Pinterest', '1:1 / 4:5 / 2:3', '主标题、生活方式、品牌色、高分辨率'],
      ['邮件通讯和博客头图', '16:9 或 2.35:1', '大画面视觉 + 主标题；说明型排版换 GPT Image'],
      ['Shopify 和 Squarespace 首屏图', '16:9', '新品发布、品牌色、产品和生活方式场景'],
      ['Etsy 商品页封面', '1:1 或 4:5', '手作感、材质细节、生活方式构图'],
      ['课程封面', '16:9', '课程名 + 学科元素 + 品牌色 + 高分辨率'],
      ['电商详情页配图', '1:1 或 4:3', '产品 + 使用场景 + 柔和光线 + 详情页风格'],
      ['品牌海报', '3:4 或 16:9', '主标题 + 产品 + 品牌视觉'],
      ['大促活动主视觉', '按平台', '提示词写促销主题、品牌色和主标题']
    ]
  ),
  'z-image-ai-generator-review': ref(
    '广告草图试方向',
    'Z Image Turbo 我用来连出多个方向，定稿再同页换 FLUX 或 Seedream。',
    ['平台和类型', '比例', '试方向要点'],
    [
      ['Facebook 广告', '1:1 或 4:5', '促销主题、产品前景、高对比配色'],
      ['Instagram 帖子', '1:1 或 4:5', '生活方式 + 品牌色'],
      ['Meta 广告图', '1:1 或 4:5', '先试配色和构图，大字区域留给 GPT Image'],
      ['TikTok 商品图', '9:16', '动感构图、产品清晰、促销信息'],
      ['YouTube 缩略图', '16:9', '高对比、主体大、构图先试后精修'],
      ['Google Shopping 促销图', '1:1', '产品清楚、背景简洁、促销主题先定方向'],
      ['eBay 和 Walmart 活动图', '1:1 或 16:9', '促销横幅、产品前景、品牌色'],
      ['电商横幅图', '16:9', '促销横幅图、品牌色、活动主题'],
      ['活动海报', '3:4 或 1:1', '连出 3–5 版筛方向，终稿精修']
    ]
  ),
  'stable-diffusion-online-generator': ref(
    'SD 3.5 创作类型速查',
    '不想折腾本地 SD 和 ComfyUI 时，在线版按创作类型对照下面这张表写提示词就行。',
    ['创作类型', '提示词方向', '和 Midjourney 比'],
    [
      ['插画和概念图', '风格词 + 主体 + 构图', 'SD 偏风格控制；MJ 氛围感有时更强'],
      ['动漫和二次元', '动漫风、角色、配色', 'SD 3.5 在线不用显卡'],
      ['角色设定', '服装、姿态、世界观 + 概念艺术', '见上文插画章节示例'],
      ['游戏原画和场景', '场景、道具、超细节、体积光', '探索完商业终稿换 FLUX 或 Seedream'],
      ['风格化头像', '肖像 + 风格词（油画、赛博）', '先宽后窄补细节'],
      ['不想装 ComfyUI', '浏览器打开 SD 3.5', '在线入门，比本地折腾省事']
    ]
  ),
  'ai-watermark-remover-online': ref(
    '去水印素材类型速查',
    '不同素材框选方式不一样——下面是我处理各类水印时的习惯对照。',
    ['素材类型', '处理要点', '后续用途'],
    [
      ['电商和商品图', '框选角落标志，避开产品主体', 'Seedream/FLUX 二次创作主图'],
      ['Shopify 独立站素材', '清理供应商图角落标志', '换背景后做系列商品图'],
      ['eBay 和 Etsy 图片', '去除日期戳、小标记或多余文字', '整理商品页图集，商用前确认授权'],
      ['Walmart Marketplace 商品图', '小范围处理边角水印', '保持主体边缘清楚'],
      ['海报和活动图', '去除角落标记或半透明标志', 'GPT Image 改标题再生成'],
      ['社媒截图', '截图越清晰越好', '参考构图，商用需确认授权'],
      ['透明 / 重复水印', '小范围多次框选', '复杂背景分块处理'],
      ['图片上的文字水印', '框选文字区域', 'AI 按周围纹理补全'],
      ['批量整理素材', '逐张框选，选区贴边', '清理后进生图模型']
    ]
  ),
  'handwriting-eraser-online': ref(
    '文档清理场景速查',
    '处理扫描件、试卷和合同，顺序我通常按下面走——矫正、擦手写、去水印可以一条链做完。',
    ['文档类型', '建议顺序', '操作技巧'],
    [
      ['试卷手写答案', '矫正 → 擦答案 → 打印', '保留印刷试题，小范围擦'],
      ['空白试卷还原', '擦答案 → 检查题干 → 打印', '适合教师备课和学生复习'],
      ['合同手写批注', '矫正 → 擦批注', '保留印刷条款'],
      ['PDF 扫描件', '导出图片 → 矫正 → 擦手写', '同上'],
      ['笔记和涂鸦', '矫正 → 分块擦除', '表格线附近小范围多次'],
      ['红笔和蓝笔', '直接擦除', '红蓝铅笔均可试'],
      ['弯曲练习册', '弯曲矫正 → 擦答案', '页面弯曲先处理'],
      ['完整清理流程', '矫正 → 擦手写 → 去水印 → OCR', '顺序不要颠倒']
    ]
  ),
  'image-crop-dewarp-online': ref(
    '文档矫正场景速查',
    '倾斜、弯曲和透视类拍照的要点——我按场景对照，避免一上来就乱试。',
    ['拍照场景', '主要问题', '矫正要点'],
    [
      ['倾斜扫描件和合同', '透视变形', '上传后自动识别边缘并拉正'],
      ['弯曲书页', '页面曲面', '可分两次：先大致拉正再微调'],
      ['收据和票据', '边缘不齐', '矫正同时裁剪多余背景'],
      ['白板照片', '透视倾斜', '校正后文字更易读，适合 OCR'],
      ['低光扫描件', '阴影和灰底', '先去阴影，再按需要增亮或灰度增强'],
      ['文字发虚的试卷', '文字边缘不清', '切边矫正后做文字锐化'],
      ['证件拍照', '边缘裁切', '请注意隐私保护'],
      ['推荐处理顺序', '多步流程', '矫正 → 擦手写 → 去水印 → OCR']
    ]
  )
}

module.exports = HUB_PLATFORM_REFS
